import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import styles from "./HowItWorksText.module.scss"

interface IHowItWorksText extends PropsWithChildren {
  position?: "center"
}

export const HowItWorksText: FC<PropsWithChildren<IHowItWorksText>> = ({
  position,

  children
}) => {
  return (
    <div className={clsx(styles.HowItWorksText, position && styles[position])}>
      {children}
    </div>
  )
}
